import { Col, Image, Row, Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ContactPagemap from "../../../assets/images/ContactPagemap.png";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import "./index.less";
const { Title, Paragraph } = Typography;

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className="PolicyPagesCommonWrapper">
      <HomePageNavbarComponent />
      <Row justify="center" className="ContactPageWrapper">
        <Row className="contact-child-main">
          <Title level={3} className="contact-child-title">
            {t("we-are-in-different-places-text")}
          </Title>
          <Paragraph className="contact-child-paragraph">{t("we-have-offices-and-teams-around-the-world")}</Paragraph>

          <Row className="ImageContainer">
            <Image src={ContactPagemap} alt="img not available" preview={false} className="contact-child-img" />
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>Montreal</span>} color="#fff">
              <div className="circleWrapper point-1">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>Brussels</span>} color="#fff">
              <div className="circleWrapper point-2">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>Wilmington</span>} color="#fff">
              <div className="circleWrapper point-3">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
            <Tooltip placement="top" title={<span style={{ color: "#000" }}>San Francisco</span>} color="#fff">
              <div className="circleWrapper point-4">
                <div className="circle-container">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="center-dot"></div>
                </div>
              </div>
            </Tooltip>
          </Row>
        </Row>
        <Row className="contact-child-main2" gutter={16}>
          <Col className="contact-child-col">
            <Title className="contact-child-text1">{t("support")}</Title>
            <Paragraph className="contact-child-text2">{t("our-team-is-here-to-help-you")}</Paragraph>
            <Link to={"/hello"} className="contact-child-link">
              contact@twizz.app
            </Link>
          </Col>
          <Col className="contact-child-col">
            <Title className="contact-child-text1">{t("creators")}</Title>
            <Paragraph className="contact-child-text2">{t("questions-contact-us-text")}</Paragraph>
            <Link to={"/hello"} className="contact-child-link">
              creators@twizz.app
            </Link>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default ContactPage;
